/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum TimeRangeId {
    Last15Minutes = 'Last15Minutes',
    Last30Minutes = 'Last30Minutes',
    Last60Minutes = 'Last60Minutes',
    Hour = 'Hour',
    PreviousHour = 'PreviousHour',
    Last3Hours = 'Last3Hours',
    Last6Hours = 'Last6Hours',
    Last12Hours = 'Last12Hours',
    Last24Hours = 'Last24Hours',
    FullDay = 'FullDay',
    Today = 'Today',
    Yesterday = 'Yesterday',
    Last2Days = 'Last2Days',
    Last3Days = 'Last3Days',
    Last7Days = 'Last7Days',
    Last14Days = 'Last14Days',
    Week = 'Week',
    WeekToDate = 'WeekToDate',
    LastWeekToNow = 'LastWeekToNow',
    Last2WeeksToNow = 'Last2WeeksToNow',
    PreviousWeek = 'PreviousWeek',
    Previous2Weeks = 'Previous2Weeks',
    Previous4Weeks = 'Previous4Weeks',
    FullMonth = 'FullMonth',
    Month = 'Month',
    MonthToDate = 'MonthToDate',
    PreviousMonth = 'PreviousMonth',
    LastMonthToNow = 'LastMonthToNow',
    Previous3Months = 'Previous3Months',
    Previous6Months = 'Previous6Months',
    Previous12Months = 'Previous12Months',
    TwoMonthsAgo = 'TwoMonthsAgo',
    ThreeMonthsAgo = 'ThreeMonthsAgo',
    Last30Days = 'Last30Days',
    FullQuarter = 'FullQuarter',
    Quarter = 'Quarter',
    QuarterToDate = 'QuarterToDate',
    LastQuarterToNow = 'LastQuarterToNow',
    LastQuarterToDate = 'LastQuarterToDate',
    PreviousQuarter = 'PreviousQuarter',
    Previous2Quarters = 'Previous2Quarters',
    Previous3Quarters = 'Previous3Quarters',
    Previous4Quarters = 'Previous4Quarters',
    Last3Months = 'Last3Months',
    Last3MonthsToNow = 'Last3MonthsToNow',
    Last6MonthsToNow = 'Last6MonthsToNow',
    Last12MonthsToNow = 'Last12MonthsToNow',
    FullYear = 'FullYear',
    Year = 'Year',
    YearToDate = 'YearToDate',
    PreviousYear = 'PreviousYear',
    Previous3Years = 'Previous3Years',
    Last365Days = 'Last365Days',
    BillingCurrentMonth = 'BillingCurrentMonth',
    BillingPreviousMonth = 'BillingPreviousMonth',
    BillingCurrentQuarter = 'BillingCurrentQuarter',
    BillingPreviousQuarter = 'BillingPreviousQuarter',
    BillingPrevious3Months = 'BillingPrevious3Months',
    BillingPrevious6Months = 'BillingPrevious6Months',
    FiscalPreviousQuarter = 'FiscalPreviousQuarter',
    FiscalCurrentQuarter = 'FiscalCurrentQuarter',
    FiscalCurrentQuarterToNow = 'FiscalCurrentQuarterToNow',
    FiscalPreviousHalfYear = 'FiscalPreviousHalfYear',
    FiscalCurrentHalfYear = 'FiscalCurrentHalfYear',
    FiscalPreviousYear = 'FiscalPreviousYear',
    FiscalCurrentYear = 'FiscalCurrentYear',
    FiscalCurrentYearToNow = 'FiscalCurrentYearToNow',
    FiscalLast3Years = 'FiscalLast3Years',
    FiscalYearToDate = 'FiscalYearToDate',
    WeekToDateT2 = 'WeekToDateT2',
    LastWeekToDateT2 = 'LastWeekToDateT2',
    Last2WeeksToDateT2 = 'Last2WeeksToDateT2',
    MonthToDateT2 = 'MonthToDateT2',
    LastMonthToDateT2 = 'LastMonthToDateT2',
    Last3MonthsToDateT2 = 'Last3MonthsToDateT2',
    Last6MonthsToDateT2 = 'Last6MonthsToDateT2',
    Last12MonthsToDateT2 = 'Last12MonthsToDateT2',
    LastQuarterToDateT2 = 'LastQuarterToDateT2',
    YearToDateT2 = 'YearToDateT2',
    FiscalLastQuarterToDateT2 = 'FiscalLastQuarterToDateT2',
    FiscalCurrentQuarterToDateT2 = 'FiscalCurrentQuarterToDateT2',
    FiscalCurrentYearToDateT2 = 'FiscalCurrentYearToDateT2',
    All = 'All'
}
